import keyBy from 'lodash/keyBy';
import { useMemo } from 'react';

import { IntegrationV1 } from '~/components/Admin/IntegrationPage/IntegrationPageUtils';
import { User } from '~/types/User';

import { ESignatureIntegration } from '../../types';
import { mappedEnrichedIntegrations } from './mappedEnrichedIntegrations';
import { normalizeESignatureIntegrations } from './normalizeESignatureIntegrations';
import { useGetESignatureQueries } from './useGetESignatureQueries';

export const useESignatureIntegrationData = (
  currentUser: User,
  isV2Enable = false,
) => {
  const { integrationV1, vendors, integrations, isLoading, error, refetch } =
    useGetESignatureQueries(isV2Enable);
  const mappedESignatureIntegrations: ESignatureIntegration[] = useMemo(
    () => normalizeESignatureIntegrations(vendors, integrations),
    [vendors, integrations],
  );

  const esignatureIntegrationsData = isV2Enable
    ? mappedESignatureIntegrations
    : (integrationV1 as IntegrationV1[]) || [];

  const enrichedIntegrations = useMemo(
    () =>
      mappedEnrichedIntegrations(
        esignatureIntegrationsData,
        currentUser,
        isV2Enable,
      ),
    [esignatureIntegrationsData, currentUser, isV2Enable],
  );

  return {
    integrationsMap: keyBy(enrichedIntegrations, '_key'),
    isLoading,
    error,
    refetch,
  };
};
